import * as actionType from './type'

const INITIAL_STATE = {
    error: "",
    workflows: [],
    workflowLogs: [],
    workflowLogDetail: null,
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionType.RECEIVED_ALL_WORKFLOWS: {
            return {
                ...state,
                workflows: action.payload
            }
        }

        case actionType.RECEIVED_WORKFLOW_LOGS: {
            return {
                ...state,
                workflowLogs: action.payload
            }
        }

        case actionType.RECEIVED_WORKFLOW_LOG_DETAIL: {
            return {
                ...state,
                workflowLogDetail: action.payload
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                error: action.payload
            }
        }

        default:
            return state;
    }
}
